module.exports = __webpack_public_path__ + "img/ventilation.72c6e8b6.svg";